import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-456e929a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = { class: "inner1" }
const _hoisted_7 = { class: "title_left" }
const _hoisted_8 = {
  key: 0,
  class: "error-message"
}
const _hoisted_9 = { class: "" }
const _hoisted_10 = { style: {"width":"100%"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"13%"} }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"13%"} }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode("申請期間 ")
], -1))
const _hoisted_21 = ["max"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-center" }, "~", -1))
const _hoisted_23 = ["max"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "申請種別", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "ステータス", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = { style: {"width":"100%"} }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"13%"} }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"13%"} }, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"18%"} }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"7%"} }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"7%"} }, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "キーワード", -1))
const _hoisted_42 = { colspan: "3" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "希望納期", -1))
const _hoisted_44 = ["max"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "まで", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "完了しているものを除く", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_48 = { style: {"width":"100%"} }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"70%"} }, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"7%"} }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "申請者", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_55 = { class: "form-control-title" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_57 = { class: "header" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "申請履歴")
], -1))
const _hoisted_59 = { class: "page-size-selector" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "表示件数 ", -1))
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "" }
const _hoisted_64 = {
  key: 0,
  class: ""
}
const _hoisted_65 = {
  key: 1,
  class: ""
}
const _hoisted_66 = { class: "table table-bordered" }
const _hoisted_67 = { class: "thead-light" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_btnUpdate" }, "編集", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_SinseiUser" }, "申請者", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_SinseiTitle" }, "申請タイトル", -1))
const _hoisted_71 = {
  "data-name": "mBtnUpdate",
  style: {"text-align":"center"}
}
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  "data-name": "mShinseiNo",
  class: "form-control-center"
}
const _hoisted_74 = {
  "data-name": "mShinseiDate",
  class: "form-control-center"
}
const _hoisted_75 = { "data-name": "mShinseiUser" }
const _hoisted_76 = { class: "ellipsis-label" }
const _hoisted_77 = { "data-name": "mShinseiCategory" }
const _hoisted_78 = { "data-name": "mShinseiTitle" }
const _hoisted_79 = ["onClick"]
const _hoisted_80 = {
  key: 0,
  class: "com_icon_new_app"
}
const _hoisted_81 = { "data-name": "mShinseiStatus" }
const _hoisted_82 = {
  "data-name": "mWishDate",
  class: "form-control-center"
}
const _hoisted_83 = {
  "data-name": "mLastUpdate",
  class: "form-control-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_content_pagination = _resolveComponent("content-pagination")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, [
                _createTextVNode(" 申請状況一覧 "),
                _createElementVNode("button", {
                  type: "button",
                  name: "btnNew",
                  class: "btn btn-primary",
                  style: {"margin-left":"15px"},
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNewApp && _ctx.onNewApp(...args)))
                }, " 新規申請 ")
              ])
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              _hoisted_19,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_20,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.appSearchCond.appDateFrom) = $event)),
                      max: _ctx.AppConstants.MAX_DATE_VALUE,
                      class: "form-control"
                    }, null, 8, _hoisted_21), [
                      [_vModelText, _ctx.appSearchCond.appDateFrom]
                    ])
                  ]),
                  _hoisted_22,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.appSearchCond.appDateTo) = $event)),
                      max: _ctx.AppConstants.MAX_DATE_VALUE,
                      class: "form-control"
                    }, null, 8, _hoisted_23), [
                      [_vModelText, _ctx.appSearchCond.appDateTo]
                    ])
                  ]),
                  _hoisted_24,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.appSearchCond.appType) = $event)),
                      class: "form-control"
                    }, [
                      _hoisted_25,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appCategoryList, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.value,
                          value: item.value
                        }, _toDisplayString(item.text), 9, _hoisted_26))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.appSearchCond.appType]
                    ])
                  ]),
                  _hoisted_27,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.appSearchCond.status) = $event)),
                      class: "form-control"
                    }, [
                      _hoisted_28,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.value,
                          value: item.value
                        }, _toDisplayString(item.text), 9, _hoisted_29))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.appSearchCond.status]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_30, [
              _hoisted_31,
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _hoisted_36,
              _hoisted_37,
              _hoisted_38,
              _hoisted_39,
              _hoisted_40,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_41,
                  _createElementVNode("td", _hoisted_42, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.appSearchCond.keyword) = $event)),
                      type: "text",
                      placeholder: "申請タイトルと申請内容を検索します",
                      maxlength: "50",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.appSearchCond.keyword]
                    ])
                  ]),
                  _hoisted_43,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.appSearchCond.wishDate) = $event)),
                      max: _ctx.AppConstants.MAX_DATE_VALUE,
                      class: "form-control"
                    }, null, 8, _hoisted_44), [
                      [_vModelText, _ctx.appSearchCond.wishDate]
                    ])
                  ]),
                  _hoisted_45,
                  _hoisted_46,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.appSearchCond.disableFinised) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.appSearchCond.disableFinised]
                    ])
                  ]),
                  _hoisted_47
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_48, [
              _hoisted_49,
              _hoisted_50,
              _hoisted_51,
              _hoisted_52,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_53,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.appSearchCond.userName) = $event)),
                      type: "text",
                      maxlength: "20",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.appSearchCond.userName]
                    ])
                  ]),
                  _hoisted_54,
                  _createElementVNode("td", _hoisted_55, [
                    _createElementVNode("button", {
                      type: "button",
                      name: "btnSearch",
                      class: "btn btn-primary",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
                    }, " 検索 ")
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("div", _hoisted_59, [
              _hoisted_60,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dispNums, (size, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: size }, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.changePageSize(size)), ["prevent"]),
                    class: _normalizeClass({ active: _ctx.itemsPerPage === size, disabled: _ctx.isSearchMode })
                  }, _toDisplayString(size) + "件 ", 11, _hoisted_61),
                  (index < _ctx.dispNums.length - 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_62, " | "))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_63, [
            (!_ctx.isSearchMode)
              ? (_openBlock(), _createElementBlock("label", _hoisted_64, "件数："))
              : _createCommentVNode("", true),
            (!_ctx.isSearchMode)
              ? (_openBlock(), _createElementBlock("label", _hoisted_65, _toDisplayString(_ctx.appDataList.length.toLocaleString()) + " 件 ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_66, [
              _createElementVNode("thead", _hoisted_67, [
                _createElementVNode("tr", null, [
                  _hoisted_68,
                  _createElementVNode("th", {
                    class: _normalizeClass([
                'col_SinseiNo',
                'sortable',
                _ctx.isDirectionASC('shinseiNo') ? 'asc' : 'desc',
              ]),
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onSortItem('shinseiNo')))
                  }, " 申請No. ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([
                'col_SinseiDate',
                'sortable',
                _ctx.isDirectionASC('shinseiDate') ? 'asc' : 'desc',
              ]),
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onSortItem('shinseiDate')))
                  }, " 申請日 ", 2),
                  _hoisted_69,
                  _createElementVNode("th", {
                    class: _normalizeClass([
                'col_SinseiCategiry',
                'sortable',
                _ctx.isDirectionASC('shinseiCategory') ? 'asc' : 'desc',
              ]),
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onSortItem('shinseiCategory')))
                  }, " 申請種別 ", 2),
                  _hoisted_70,
                  _createElementVNode("th", {
                    class: _normalizeClass([
                'col_SinseiStatus',
                'sortable',
                _ctx.isDirectionASC('shinseiStatus') ? 'asc' : 'desc',
              ]),
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onSortItem('shinseiStatus')))
                  }, " ステータス ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([
                'col_WishDate',
                'sortable',
                _ctx.isDirectionASC('wishDate') ? 'asc' : 'desc',
              ]),
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSortItem('wishDate')))
                  }, " 希望納期 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([
                'col_LastUpdate',
                'sortable',
                _ctx.isDirectionASC('lastUpdate') ? 'asc' : 'desc',
              ]),
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onSortItem('lastUpdate')))
                  }, " 最終更新日 ", 2)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedData, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.applicationNo
                  }, [
                    _createElementVNode("td", _hoisted_71, [
                      _createElementVNode("button", {
                        type: "button",
                        name: "mBtnUpdate",
                        class: "btn btn-primary btn-sm",
                        onClick: ($event: any) => (_ctx.onEdit(item.applicationNo))
                      }, " 編集 ", 8, _hoisted_72)
                    ]),
                    _createElementVNode("td", _hoisted_73, _toDisplayString(item.applicationNo), 1),
                    _createElementVNode("td", _hoisted_74, _toDisplayString(item.applicationDate), 1),
                    _createElementVNode("td", _hoisted_75, [
                      _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_76, [
                        _createTextVNode(_toDisplayString(item.applicationUser), 1)
                      ])), [
                        [_directive_tooltip, item.applicationUser]
                      ])
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("td", _hoisted_77, [
                      _createTextVNode(_toDisplayString(item.applicationCategoryName), 1)
                    ])), [
                      [_directive_tooltip, item.applicationCategoryName]
                    ]),
                    _createElementVNode("td", _hoisted_78, [
                      _withDirectives((_openBlock(), _createElementBlock("span", {
                        class: "ellipsis-link",
                        onClick: ($event: any) => (_ctx.onEdit(item.applicationNo, true))
                      }, [
                        _createTextVNode(_toDisplayString(item.applicationTitle), 1)
                      ], 8, _hoisted_79)), [
                        [_directive_tooltip, item.applicationTitle]
                      ]),
                      (item.agNewFlg)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_80, " NEW"))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("td", _hoisted_81, [
                      _createTextVNode(_toDisplayString(item.statusName), 1)
                    ])), [
                      [_directive_tooltip, item.statusName]
                    ]),
                    _createElementVNode("td", _hoisted_82, _toDisplayString(item.wishDate), 1),
                    _createElementVNode("td", _hoisted_83, _toDisplayString(item.lastUpdDate), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createVNode(_component_content_pagination, {
              "current-page": _ctx.currentPage,
              "total-pages": _ctx.totalPages,
              "items-per-page": _ctx.itemsPerPage,
              onPageChanged: _ctx.handlePageChange
            }, null, 8, ["current-page", "total-pages", "items-per-page", "onPageChanged"])
          ])
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}